export default {
      id: "mic-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#mic-usage",
      toString: function () {
        return this.url;
      }
    }